import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1920,1694 L1920,1806.94118 L0,1806.94118 L0,1694 L1920,1694 Z M1016.47059,338.882353 L1016.47059,993.150588 L1258.84235,750.665882 L1338.80471,830.515294 L960,1209.32 L581.195294,830.515294 L661.157647,750.665882 L903.529412,993.150588 L903.529412,338.882353 L1016.47059,338.882353 Z M1750.58824,113 L169.411765,113 C76.0094118,113 0,189.009412 0,282.411765 L0,1468.29412 L56.4705882,1468.29412 L112.941176,1468.29412 L1807.05882,1468.29412 L1863.52941,1468.29412 L1920,1468.29412 L1920,282.411765 C1920,189.009412 1843.99059,113 1750.58824,113 L1750.58824,113 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCollapseSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCollapseSolid, _Component);

  var _super = _createSuper(IconCollapseSolid);

  function IconCollapseSolid() {
    _classCallCheck(this, IconCollapseSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCollapseSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCollapse",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCollapseSolid.displayName = "IconCollapseSolid";
  return IconCollapseSolid;
}(Component);

IconCollapseSolid.glyphName = 'collapse';
IconCollapseSolid.variant = 'Solid';
IconCollapseSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCollapseSolid;
export { IconCollapseSolid };